import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BillingGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private msalService = inject(MsalService);

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    try {
      const groups = this.authService.currentUser()?.group ?? [];
      if (groups.includes('billing') || groups.includes('superadmin')) {
        return true;
      }
      if (groups.includes('timemanager') && state.url.includes('dashboard-billing-time-management')) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

}
